import { useEffect, useState } from "react";
import classes from "./Onboard.module.css";
import promix from "../../Assets/Promix.svg";
import back from "../../Assets/back.svg";
import search from "../../Assets/search.svg";
import { Search, Calculator, Download, Upload, Plus } from "lucide-react";

const Onboard = () => {
  const [selectedCount, setSelectedCount] = useState(0);
  const accounts = [
    { id: 1000, name: "Cash at Bank", group: "Current Assets" },
    { id: 1100, name: "Petty Cash", group: "Current Assets" },
    { id: 1200, name: "Accounts Receivable", group: "Current Assets" },
  ];
  // Count once on mount
  useEffect(() => {
    setSelectedCount(accounts.length); // All are pre-checked
  }, []);
  // These can be selected/deselected
  const optionalAccounts = [
    { id: 1300, name: "Prepaid Expenses", group: "Current Assets" },
    { id: 1500, name: "Equipment", group: "Fixed Assets" },
    { id: 1600, name: "Furniture & Fixtures", group: "Fixed Assets" },
  ];
  const requiredLiabilities = [
    { id: 2000, name: "Accounts Payable", group: "Current Liabilities" },
    { id: 2100, name: "VAT Payable", group: "Current Liabilities" },
    { id: 2200, name: "Accrued Expenses", group: "Current Liabilities" },
  ];

  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <p className={classes.scythe}>Set Up Your Chart of Accounts</p>
      <p className={classes.knight}>
        Select the accounts that match your business needs
      </p>

      <div className={classes.contor}>
        <div className={classes.cmyk}>
          <div className={classes.cyntheir}>FinConne Technovation Limited</div>
          <div className={classes.cotton}>
            <img src={back} />
            <div className={classes.back}>Back</div>
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.leftGroup}>
            <div className={classes.searchWrapper}>
              <Search className={classes.searchIcon} />
              <input
                type="text"
                placeholder="Search accounts..."
                className={classes.searchInput}
              />
            </div>
            <span className={classes.selectedText}>
              {selectedCount} accounts selected
            </span>{" "}
          </div>

          <div className={classes.rightGroup}>
            <button
              className={classes.outlineGreen}
              onClick={() => setShowModal(true)}
            >
              <Calculator size={16} />
              Trial Balance
            </button>

            <button className={classes.outlineGreen}>
              <Download size={16} />
              Template
            </button>

            <button className={classes.outlineGreen}>
              <Upload size={16} />
              Upload CSV
            </button>

            <button className={classes.filledGreen}>
              <Plus size={16} />
              Add Custom Account
            </button>
          </div>
        </div>

        {showModal && (
          <div className={classes.modalOverlay}>
            <div className={classes.modal}>
              <div className={classes.summarySection}>
                <div className={classes.cardGreen}>
                  <p>Total Credits</p>
                  <h3>₦8,400,000.00</h3>
                </div>
                <div className={classes.cardBlue}>
                  <p>Total Debits</p>
                  <h3>₦4,950,000.00</h3>
                </div>
                <div className={classes.cardYellow}>
                  <p>Differences</p>
                  <h3>₦3,200,000.00</h3>
                </div>
                <div className={classes.cardYellow1}>
                  <button className={classes.autoBalance}>Auto Balance</button>
                </div>
              </div>

              <div className={classes.alertBox}>
                <span>⚠️</span> Trial Balance Out of Balance
                <p>
                  Your total debits (₦12,200,000) don't equal your total credits
                  (₦14,000,000). Adjust the balances or use Auto Balance to
                  automatically adjust to the nearest equity account.
                </p>
              </div>

              <table className={classes.table}>
                <thead>
                  <tr>
                    <th>Account code</th>
                    <th>Account Name</th>
                    <th>Type</th>
                    <th>Balance</th>
                    <th>Debit/Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "Assets",
                      balance: "₦2,500,000.00",
                      mode: "Credit",
                    },
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "Assets",
                      balance: "₦2,500,000.00",
                      mode: "Debit",
                    },
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "liabilities",
                      balance: "₦2,500,000.00",
                      mode: "Debit",
                    },
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "Assets",
                      balance: "₦2,500,000.00",
                      mode: "Debit",
                    },
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "Assets",
                      balance: "₦2,500,000.00",
                      mode: "Credit",
                    },
                    {
                      code: "INV-001",
                      name: "Cash at Bank",
                      type: "Assets",
                      balance: "₦2,500,000.00",
                      mode: "Credit",
                    },
                  ].map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.code}</td>
                      <td>{item.name}</td>
                      <td>{item.type}</td>
                      <td>{item.balance}</td>
                      <td>
                        <span
                          className={
                            item.mode === "Credit"
                              ? classes.credit
                              : classes.debit
                          }
                        >
                          {item.mode}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className={classes.footer}>
                <button
                  className={classes.back}
                  onClick={() => setShowModal(false)}
                >
                  ← Back
                </button>
                <button className={classes.save}>📄 Save Trial Balance</button>
              </div>
            </div>
          </div>
        )}
        {/* FIRST SECTION */}
        <div className={classes.paratan}>
          <div className={classes.son_ifon}>
            <button className={classes.assets}>Assets</button>
            <p className={classes.monitor}>AssetsAccount</p>
          </div>

          <div className={classes.put_Icon}>
            <div className={classes.curote}>
              {accounts.map((acc) => (
                <label key={acc.id} className={classes.healer}>
                  <div className={classes.papermarche}>
                    <input
                      className={classes.checkboxInput}
                      type="checkbox"
                      checked
                      disabled
                    />
                    <p className={classes.machine}>{acc.id}</p>
                    <button className={classes.fire}>Required</button>
                  </div>
                  <p className={classes.rino}>{acc.name}</p>
                  <p className={classes.brunt}>{acc.group}</p>
                </label>
              ))}
            </div>

            {/* SECOND SLIDE */}
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>1300</p>
                </div>
                <p className={classes.rino}>Prepaid Expenses</p>
                <p className={classes.brunt}>Current Assets</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>1500</p>
                </div>
                <p className={classes.rino}>Equipment</p>
                <p className={classes.brunt}>Fixed Assets</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>1600</p>
                </div>
                <p className={classes.rino}>Furniture & Fixtures</p>
                <p className={classes.brunt}>Fixed Assets</p>
              </label>
            </div>
          </div>
        </div>

        {/* SECOND SECTION */}

        <div className={classes.paratan}>
          <div className={classes.son_ifon}>
            <button className={classes.asset2}>Liabilities</button>
            <p className={classes.monitor}>Liabilities Account</p>
          </div>

          <div className={classes.put_Icon}>
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>2000</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Accounts Payable</p>
                <p className={classes.brunt}>Current Liabilities</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>2100</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>VAT Payable</p>
                <p className={classes.brunt}>Current Liabilities</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>2200</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Accrued Expenses</p>
                <p className={classes.brunt}>Current Liabilities</p>
              </label>
            </div>

            {/* SECOND SLIDE */}
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>2500</p>
                </div>
                <p className={classes.rino}>Long-term Debt</p>
                <p className={classes.brunt}>Long-term Liabilities</p>
              </label>
            </div>
          </div>
        </div>

        {/* THIRD SECTION */}

        <div className={classes.paratan3}>
          <div className={classes.son_ifon}>
            <button className={classes.equity}>Equity</button>
            <p className={classes.monitor}>EquityAccounts</p>
          </div>

          <div className={classes.put_Icon}>
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>3000</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Share Capital</p>
                <p className={classes.brunt}>Equity</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>3100</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Retained Earnings</p>
                <p className={classes.brunt}>Equity</p>
              </label>
            </div>

            {/* SECOND SLIDE */}
          </div>
        </div>

        {/* FORTH SECTION */}

        <div className={classes.paratan4}>
          <div className={classes.son_ifon}>
            <button className={classes.revenue}>Revenue</button>
            <p className={classes.monitor}>RevenueAccounts</p>
          </div>

          <div className={classes.put_Icon}>
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>4000</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Sales Revenue</p>
                <p className={classes.brunt}>Operating Revenue</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>4100</p>
                </div>
                <p className={classes.rino}>Service Revenue</p>
                <p className={classes.brunt}>Operating Revenue</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>4900</p>
                </div>
                <p className={classes.rino}>Other Income</p>
                <p className={classes.brunt}>Other Revenue</p>
              </label>
            </div>

            {/* SECOND SLIDE */}
          </div>
        </div>

        {/* FIFTH SECTION */}

        <div className={classes.paratan5}>
          <div className={classes.son_ifon}>
            <button className={classes.expenses}>Expenses</button>
            <p className={classes.monitor}>ExpensesAccount</p>
          </div>

          <div className={classes.put_Icon}>
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>5000</p>
                </div>
                <p className={classes.rino}>Cost of Goods Sold</p>
                <p className={classes.brunt}>Cost of Sales</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6000</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Salaries & Wages</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6100</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Rent Expense</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
            </div>

            {/* SECOND SLIDE */}
            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6200</p>
                  <button className={classes.fire}>Required</button>
                </div>
                <p className={classes.rino}>Utilities</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6300</p>
                </div>
                <p className={classes.rino}>Office Supplies</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6400</p>
                </div>
                <p className={classes.rino}>Professional Fees</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
            </div>

            {/* THIRD SLIDE */}

            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6500</p>
                </div>
                <p className={classes.rino}>Marketing & Advertising</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6600</p>
                </div>
                <p className={classes.rino}>Travel & Entertainment</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>

              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6700</p>
                </div>
                <p className={classes.rino}>Insurance</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
            </div>

            {/* FORTH SLIDE */}

            <div className={classes.curote}>
              <label className={classes.healer}>
                <div className={classes.papermarche}>
                  <input className={classes.checkboxInput} type="checkbox" />
                  <p className={classes.machine}>6800</p>
                </div>
                <p className={classes.rino}>Depreciation</p>
                <p className={classes.brunt}>Operating Expenses</p>
              </label>
            </div>
          </div>
        </div>

        <div className={classes.lastDiv}>
          <p className={classes.bodermCont}>
            Don't worry about getting it perfect
          </p>
          <p className={classes.dup_cort}>
            You can always add, remove, or modify accounts later from your
            Settings. Start with the essentials and expand as your business
            grows.
          </p>
        </div>

        <div className={classes.otrarBorad}>
          <div className={classes.cotton}>
            <img src={back} />
            <div className={classes.back}>Back</div>
          </div>

          <button className={classes.bloc_on}>
            <span className={classes.horns}>Complete Setup </span>
            <span>(11 accounts)</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboard;
